import React from 'react';

export const PRODUCT_SHORT = { pro_monthly: 'Pro Monthly', pro_annual: 'Pro Annual', officials_annual: 'Officials Scheduling', bundle_annual: 'Pro + Officials Bundle', bundle_flex: 'Pro + Officials (Flexible)', card_test: 'Card test ($1)' };
export const KIND_LABEL = { initial: 'New purchase', renewal: 'Auto-renewal', renewal_manual: 'Manual renewal', card_update: 'Card update', switch: 'Switch to annual', test: 'Gateway test', card_switch: 'PayPal → card' };
export const statusText = (s) => (s || '').replaceAll('_', ' ');

export const GatewayTag = ({ gateway }) => (
  <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-black uppercase tracking-wider ${
    gateway === 'paypal' ? 'bg-amber-100 text-amber-800' : 'bg-[#00247D]/10 text-[#00247D]'}`}>
    {gateway === 'paypal' ? 'PayPal' : 'Card'}
  </span>
);

export const TestTag = () => (
  <span className="inline-flex ml-1 px-1.5 py-0.5 rounded bg-amber-400 text-[9px] font-black uppercase tracking-wider text-slate-900">Test</span>
);

export const Th = ({ children, right }) => (
  <th className={`px-3 py-2 text-[11px] font-bold text-slate-500 uppercase tracking-wide whitespace-nowrap ${right ? 'text-right' : ''}`}>{children}</th>
);

export const Sel = ({ value, onChange, options, testId, className = '' }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className={`border border-slate-200 rounded-md px-3 h-10 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#00247D]/30 ${className}`}>
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);
